import React, { useState, useEffect } from 'react';
import apiService from '../api/apiService';
import './TablePages.css';

const Payments: React.FC = () => {
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await apiService.get('/admin/payments');
        setList(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const formatDate = (s: string) => (s ? new Date(s).toLocaleString() : '-');

  if (loading) return <p>Loading...</p>;

  return (
    <div className="table-page">
      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Order #</th>
              <th>Payment method</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {list.map((row, idx) => (
              <tr key={row.order_id ?? idx}>
                <td>{row.order_number}</td>
                <td>{row.payment_method ?? '-'}</td>
                <td>{row.payment_status ?? '-'}</td>
                <td>₹{row.amount}</td>
                <td>{formatDate(row.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Payments;
